function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowM01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 13"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h15v13H0z",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h11.928",
  "data-name": "Line 11",
  style: {
    fill: "none",
    stroke: "#9d9d9d"
  },
  transform: "translate(1.295 6.5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m-8949.46-8528.566 4.681 4.679-4.681 4.68",
  "data-name": "Path 468",
  style: {
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#9d9d9d"
  },
  transform: "translate(8958.388 8530.386)"
}));
export default SvgIconArrowM01;